import { render, staticRenderFns } from "./PorletGDS.vue?vue&type=template&id=4dbe68f8&"
import script from "./PorletGDS.vue?vue&type=script&lang=js&"
export * from "./PorletGDS.vue?vue&type=script&lang=js&"
import style0 from "./PorletGDS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports